module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }